var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      staticClass: "w-100",
      attrs: { "toggle-class": "border-0 bg-none m-md-2 text-dark" },
      model: {
        value: _vm.language,
        callback: function ($$v) {
          _vm.language = $$v
        },
        expression: "language",
      },
    },
    [
      _c("template", { slot: "button-content" }, [
        _c("img", {
          staticClass: "flag-nav",
          attrs: {
            src: _vm.language === "FR" ? _vm.logoFlagFR : _vm.logoFlagEN,
          },
        }),
        _vm._v(_vm._s(_vm.labelLanguage) + "\n  "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.options, function (option) {
        return _c(
          "b-dropdown-item",
          {
            key: option.value,
            on: {
              click: function ($event) {
                return _vm.languageCountry(option.value)
              },
            },
          },
          [
            option.value === "FR"
              ? _c("img", {
                  staticClass: "flag-nav",
                  attrs: { src: _vm.logoFlagFR },
                })
              : _c("img", {
                  staticClass: "flag-nav",
                  attrs: { src: _vm.logoFlagEN },
                }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(option.text))]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }